import { ListItem } from "@mui/material"
import { styled } from "@mui/material/styles"
import LoadingTypography from "components/skeleton/LoadingTypography"
import { StyledBox } from "shared/styled/General"

const StyledListItem = styled(ListItem)({
  padding: "14px 0",
  alignItems: "flex-start !important"
})

export const VehicleLoadingItem = () => {
  return (
    <StyledListItem>
      <StyledBox>
        <LoadingTypography variant="body" />
      </StyledBox>
    </StyledListItem>
  )
}
